<template>
    <p>Волна комплексной модернизации: {{ count ? count : 'не обозначено' }}</p>
</template>

<script>
export default {
    props: {
        count: {
            type: Number,
        }
    }
}
</script>